import { useEffect } from 'react';
import {
  localDate,
  type LocalDate,
  type PaymentsSettings,
  type PaymentsSnapshot,
} from '@tahi/core';
import { runInstallmentCatchUp } from '../../data/commands/payments';
import { useCommandEnv, useData } from '../../data/hooks';
import {
  getPaymentsSettings,
  loadPaymentsSnapshot,
  PAYMENTS_TABLES,
} from '../../data/repos/payments';
import { useQuery } from '../../data/useQuery';

export const PAYMENTS_BASE = '/m/payments';

export function useToday(): LocalDate {
  return localDate(new Date(), useData().tz);
}

/** Every payee, due row, payment, installment and card purchase; undefined while loading. */
export function usePaymentsSnapshot(): PaymentsSnapshot | undefined {
  const { userId } = useData();
  return useQuery(PAYMENTS_TABLES, (db) => loadPaymentsSnapshot(db, userId), [userId]).data;
}

/** v0.7.4: the Payments settings singleton (defaults before the first write); undefined while loading. */
export function usePaymentsSettings(): PaymentsSettings | undefined {
  const { userId } = useData();
  return useQuery(['payments_settings'], (db) => getPaymentsSettings(db, userId), [userId]).data;
}

/** Installment months whose day has come get their expense when a Payments screen opens. */
export function useInstallmentCatchUp(): void {
  const env = useCommandEnv();
  useEffect(() => {
    void runInstallmentCatchUp(env).catch((err: unknown) =>
      console.warn('Tahi: installment catch-up failed', err),
    );
  }, [env]);
}
